// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__23MrU","buttons":"SendReceipts_buttons__1rzpy","email":"SendReceipts_email__1Jufi","bookApptTitle":"SendReceipts_bookApptTitle__c22iJ"};